import React, {Fragment} from "react";
import Sidebar from "../../../components/Sidebar";
import NsAccordion from "../../../components/accordion/NsAccordion";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import {Tag} from 'primereact/tag';

import {
    getPercentuale,
    getStrRgba,
    getTextColorForBackgroundStrRgba
} from "../../../utility/common";

export default function ListKpiView({
                                        kpi,
                                        filtroKpi,
                                        totKpi,
                                        totPagine,
                                        isMobile,
                                        getAlberoStruttura,
                                        getFiltriListKpi,
                                        updateFiltroKpi,
                                        translate,
                                        getListaKpi,
                                        statiKpi,
                                        onRowKpiClicked,
                                        onOrderByKpi,
                                        orderByCol,
                                        orderByDir,
                                    }) {

    return (
        <div className={"container-fluid pt-3"}>
            <Fragment>
                <Sidebar
                    sidebarContent={() => {
                        return isMobile ?
                            <NsAccordion
                                titolo={'Struttura kpi'}
                                label={'fas fa-stream'}>
                                {
                                    getAlberoStruttura()
                                }
                            </NsAccordion> &&
                            <NsAccordion //*Sara*
                                titolo={'Filtri'}
                                label={'fas fa-filter'}>
                                {
                                    getFiltriListKpi()
                                }
                            </NsAccordion>
                            : getAlberoStruttura()
                    }}
                >
                    <Fragment>
                        <NsDataTable
                            data={kpi}
                            totRighe={totKpi}
                            pagina={filtroKpi.pagina}
                            totalePagine={totPagine}
                            handlerCambioPagina={(nuovaPagina) => {
                                updateFiltroKpi('pagina', nuovaPagina);
                            }}
                            columns={[
                                {
                                    name: translate('Codice'),
                                    selector: row => row.codice,
                                    sortable: true,
                                    filtroHeader: {
                                        lazy: true,
                                        updateFilter: (val) => {
                                            updateFiltroKpi('codice', val);
                                        },
                                        filter: getListaKpi,
                                        startVal: filtroKpi.codice
                                    },
                                    dbcol: 'codice'
                                },
                                {
                                    name: translate('Descrizione'),
                                    selector: row => row.descrizione,
                                    sortable: true,
                                    filtroHeader: {
                                        lazy: true,
                                        updateFilter: (val) => {
                                            updateFiltroKpi('descrizione', val);
                                        },
                                        filter: getListaKpi,
                                        startVal: filtroKpi.descrizione
                                    },
                                    dbcol: 'descrizione'
                                },
                                {
                                    name: translate('Perimetro'),
                                    selector: row => row.tipo_imp_dati,
                                    sortable: true,
                                    filtroHeader: {
                                        lazy: true,
                                        updateFilter: (val) => {
                                            updateFiltroKpi('tipo_imp_dati', val);
                                        },
                                        filter: getListaKpi,
                                        startVal: filtroKpi.tipo_imp_dati
                                    },
                                    dbcol: 'tipo_imp_dati'
                                },
                                {
                                    name: translate('Stato'),
                                    selector: row => (
                                        row.colore_stato_kpi
                                            ?
                                            <Tag value={row.stato_kpi}
                                                 className="mr-2"
                                                 style={{
                                                     backgroundColor: getStrRgba(row.colore_stato_kpi),
                                                     color: getTextColorForBackgroundStrRgba(row.colore_stato_kpi)
                                                 }}
                                            />
                                            :
                                            row.stato_kpi
                                    ),
                                    sortable: true,
                                    filtroHeader: {
                                        lazy: true,
                                        updateFilter: (val) => {
                                            updateFiltroKpi('id_stato_kpi', val);
                                        },
                                        filter: () => {
                                        },
                                        startVal: filtroKpi.id_stato_kpi,
                                        filterOptions: statiKpi ? statiKpi.map((st) => ({
                                            id: st.id_stato_kpi,
                                            descrizione: st.descrizione
                                        })) : [],
                                        statusItemTemplate: (option) => {
                                            let optFiltrata = statiKpi.filter((opt) => opt.descrizione == option);
                                            if (optFiltrata && optFiltrata.length > 0) {
                                                return (
                                                    <Tag value={optFiltrata[0].descrizione}
                                                         className="mr-2"
                                                         style={{
                                                             backgroundColor: getStrRgba(optFiltrata[0].colore),
                                                             color: getTextColorForBackgroundStrRgba(optFiltrata[0].colore)
                                                         }}
                                                    />
                                                );
                                            }
                                        }
                                    },
                                    dbcol: 'stato_kpi'
                                },
                                {
                                    name: translate('Completamento'),
                                    selector: row => getPercentuale(row.percentuale),
                                    sortable: true,
                                    dbcol: 'percentuale',
                                    sortFunction: (a, b) => {
                                        return a.percentuale - b.percentuale;
                                    }
                                },
                            ]}
                            addFiltri={false}
                            onRowClicked={onRowKpiClicked}
                            orderBy={onOrderByKpi}
                            orderByColonna={orderByCol}
                            orderByDirezione={orderByDir}
                        />
                    </Fragment>
                </Sidebar>
            </Fragment>
        </div>
    );
}
